import i18next from 'i18next';

i18next.addResources('es', 'sectionsTable', {
    name: 'Nombre',
    description: 'Descripción',
    status: 'Etapa',
    investment: 'Inversión'
});

i18next.addResources('en', 'sectionsTable', {
    name: 'Name',
    description: 'Description',
    status: 'Stage',
    investment: 'Investment'
});

i18next.addResources('pt', 'sectionsTable', {
    name: 'Nome',
    description: 'Descrição',
    status: 'Etapa',
    investment: 'Investimento'
});
